module.exports = __webpack_public_path__ + "static/icon-campaign-3-10f83c2c60607fde925821f9aab372be.png";